module.exports = __webpack_public_path__ + "static/street-losangeles-9931c6cfc45048192c2e254815086be6.png";